import axios from 'axios';

import {
    APP__GET_COMMAND_LIST__START,
    APP__GET_COMMAND_LIST__SUCCESS,
    APP__GET_COMMAND_LIST__FAILURE,
    APP__GET_MERCHANT_LIST__START,
    APP__GET_MERCHANT_LIST__SUCCESS,
    APP__GET_MERCHANT_LIST__FAILURE,
    APP__RUN_COMMAND__START,
    APP__RUN_COMMAND__SUCCESS,
    APP__RUN_COMMAND__FAILURE,
} from './actions';

function getCommandListStart() {
    return {
        type: APP__GET_COMMAND_LIST__START,
    };
}

function getCommandListSuccess(data) {
    return {
        type: APP__GET_COMMAND_LIST__SUCCESS,
        data,
    };
}

function getCommandListFailure(error) {
    return {
        type: APP__GET_COMMAND_LIST__FAILURE,
        error,
    };
}

export function getCommandList() {
    return dispatch => {
        dispatch(getCommandListStart());

        return axios.get(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/command`)
            .then(response => {
                if (response.status === 200 && response.data && response.data.length > 0) {
                    const {
                        data: {
                            error,
                        },
                    } = response;
                    if (error) {
                        throw new Error(error);
                    }
                    dispatch(getCommandListSuccess(response.data));
                } else {
                    dispatch(getCommandListFailure(true));
                }
            })
            .catch(error => {
                dispatch(getCommandListFailure(new Error(error)));
            });
    };
}

function getMerchantListStart() {
    return {
        type: APP__GET_MERCHANT_LIST__START,
    };
}

function getMerchantListSuccess(data) {
    return {
        type: APP__GET_MERCHANT_LIST__SUCCESS,
        data,
    };
}

function getMerchantListFailure(error) {
    return {
        type: APP__GET_MERCHANT_LIST__FAILURE,
        error,
    };
}

export function getMerchantList(link = '') {
    return dispatch => {
        dispatch(getMerchantListStart());

        let baseUrl = link;
        if (baseUrl.length === 0) {
            baseUrl = `${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/merchant`;
        }
        return axios.get(baseUrl)
            .then(response => {
                if (response.status === 200 && response.data) {
                    const {
                        data: {
                            error,
                        },
                    } = response;
                    if (error) {
                        throw new Error(error);
                    }
                    dispatch(getMerchantListSuccess(response.data));
                } else {
                    dispatch(getMerchantListFailure(true));
                }
            })
            .catch(error => {
                dispatch(getMerchantListFailure(new Error(error)));
            });
    };
}

function runCommandStart(commandName) {
    return {
        type: APP__RUN_COMMAND__START,
        commandName,
    };
}

function runCommandSuccess(data, commandName) {
    return {
        type: APP__RUN_COMMAND__SUCCESS,
        data,
        commandName,
    };
}

function runCommandFailure(error, commandName) {
    return {
        type: APP__RUN_COMMAND__FAILURE,
        error,
        commandName,
    };
}

export function runCommand(command) {
    return dispatch => {
        dispatch(runCommandStart(command.commandName));
        return axios.post(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/command`, command, {
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.status === 200 && response.data) {
                    const {
                        data: {
                            errorCode,
                            errorMessage,
                        },
                    } = response;
                    if (errorMessage || errorCode) {
                        throw new Error(errorMessage || errorCode);
                    }
                    dispatch(runCommandSuccess(response.data, command.commandName));
                    if (command.command === 'merchant:update') {
                        dispatch(getMerchantList());
                    }
                } else {
                    dispatch(runCommandFailure(true));
                }
            })
            .catch(error => {
                dispatch(runCommandFailure(new Error(error), command.commandName));
            });
    };
}

export function uploadMerchantList(formData, filename, command) {
    return dispatch => axios.post(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/file`, formData, {
        headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'multipart/form-data',
        },
    })
        .then(response => {
            if (response.status === 200 && response.data.fileName === filename) {
                dispatch(runCommand(command));
            }
        });
}
